
export async function checkQuickUpdateCompleted(portfolioIdsThatWillUpdate, expectedCommentary, getState, kickSubscription) {
    await kickSubscription("AUTHOR_HOMEPAGE");
    if (portfolioIdsThatWillUpdate.length === 0) {
        return true;
    }

    // kicking subscription until activity shows up for portfolioIdsThatWillUpdate
    const {authorDetails: updatedAuthorDetails} = getState();
    if (!updatedAuthorDetails || !updatedAuthorDetails.content) {
        return false;
    }
    const activities = updatedAuthorDetails.content.activity;
    if (activities.length === 0) {
        return false;
    }
    return !!activities.find(activity => {
        return activity.action === "Update" && activity.comment === expectedCommentary;
    })
}